import { InjectionToken, Provider, Type } from '@angular/core';

import { ContentProvider } from './interfaces';

export const CONTENT_PROVIDERS = new InjectionToken<readonly ContentProvider[]>('SIGNAGE_CONTENT_PROVIDERS');

export function provideSignageContent(...providers: Type<ContentProvider>[]): Provider[] {
  return providers.map(provider => ({ provide: CONTENT_PROVIDERS, useClass: provider, multi: true }));
}
